<template>
  <div>
    <el-row>
      <el-collapse>
        <!-- 基本设置 -->
        <el-collapse-item>
          <template slot="title">
            <span class="code-font">{{ $t("message.scanningToolMsg.basicSettings.title") }}</span>
          </template>
          <div>
            <el-row>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.basicSettings.securityLevel") }}</span>
                <el-input-number v-model="scanningTools.security_level.value" :min="0" :max="2"
                  size="small"></el-input-number>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.basicSettings.backgroundLightIntensity") }}</span>
                <el-select size="small" v-model="scanningTools.illumination_level.value">
                  <el-option label="Auto" value="0"></el-option>
                  <el-option label="Level-1" value="1"></el-option>
                  <el-option label="Level-2" value="2"></el-option>
                  <el-option label="Level-3" value="3"></el-option>
                  <el-option label="Level-4" value="4"></el-option>
                  <el-option label="Level-5" value="5"></el-option>
                  <el-option label="Level-6" value="6"></el-option>
                  <el-option label="Level-7" value="7"></el-option>
                  <el-option label="Level-8" value="8"></el-option>
                  <el-option label="Level-9" value="9"></el-option>
                  <el-option label="Level-10" value="10"></el-option>
                </el-select>
              </el-col>

              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.basicSettings.exposure") }}</span>
                <el-select size="small" v-model="scanningTools.exp_level.value">
                  <el-option label="Auto" value="0"></el-option>
                  <el-option label="Low" value="1"></el-option>
                  <el-option label="Mid" value="2"></el-option>
                  <el-option label="High" value="3"></el-option>
                </el-select>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.basicSettings.centeringMode") }}</span>
                <el-select size="small" v-model="scanningTools.picklist_mode.value">
                  <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
                  <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
                </el-select>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.basicSettings.GS1") }}</span>
                <el-select size="small" v-model="scanningTools.gs1_ai_separator.value">
                  <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
                  <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
                </el-select>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.basicSettings.aimPrefix") }}</span>
                <el-select size="small" v-model="scanningTools.transfer_aim_id.value">
                  <el-option label="only gs1-128" value="2"></el-option>
                  <el-option label="all" value="1"></el-option>
                  <el-option label="close" value="0"></el-option>
                </el-select>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.basicSettings.lowPowerDelayTime") }}</span>
                <el-input-number :min="0" :max="120" size="small" v-model="scanningTools.hold_scanning_time_out.value"></el-input-number>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.basicSettings.scanTimeout") }}</span>
                <el-input-number v-model="scanningTools.scan_time_out.value" :min="1" :max="10" size="small"></el-input-number>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.basicSettings.DPMMode") }}</span>
                <el-select size="small" v-model="scanningTools.dpm.value">
                  <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
                  <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
                </el-select>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.basicSettings.fillLightSwitch") }}</span>
                <el-select size="small" v-model="scanningTools.illumination_on.value">
                  <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
                  <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
                </el-select>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.basicSettings.negativeMode") }}</span>
                <el-select size="small" v-model="scanningTools.scene_mode.value">
                  <el-option :label="$t('message.scanningToolMsg.basicSettings.standardScenarios')" value="0"></el-option>
                  <el-option :label="$t('message.scanningToolMsg.basicSettings.Scenario1')" value="1"></el-option>
                  <el-option :label="$t('message.scanningToolMsg.basicSettings.Scenario2')" value="2"></el-option>
                  <el-option :label="$t('message.scanningToolMsg.basicSettings.Scenario3')" value="3"></el-option>
                </el-select>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.basicSettings.multipleBarcodeReadingQuantity") }}</span>
                <el-input-number v-model="scanningTools.multi_code_number.value" :min="0" :max="30"
                  size="small"></el-input-number>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.basicSettings.multiBarcodeReadingDuration") }}</span>
                <el-input-number v-model="scanningTools.multi_code_timeout.value" :min="500" :max="30000" size="small"></el-input-number>
              </el-col>
            </el-row>
          </div>
        </el-collapse-item>
        <!-- code 128 -->
        <el-collapse-item>
          <template slot="title">
            <span class="code-font">Code 128</span>
          </template>
          <div>
            <el-row>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">Code 128</span>
                <el-select size="small" v-model="scanningTools.code128.value">
                  <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
                  <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
                </el-select>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.code128.minimumBarcode") }}</span>
                <el-input-number v-model="scanningTools.code128_len_min.value" :min="0" :max="80" size="small"></el-input-number>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.code128.maximumBarcode") }}</span>
                <el-input-number v-model="scanningTools.code128_len_max.value" :min="0" :max="80" size="small"></el-input-number>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">ISBT 128</span>
                <el-select size="small" v-model="scanningTools.isbt128.value">
                  <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
                  <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
                </el-select>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">GS1 128</span>
                <el-select size="small" v-model="scanningTools.gs1128.value">
                  <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
                  <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
                </el-select>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.code128.quietZone") }}</span>
                <el-select size="small" v-model="scanningTools.code128_quiet_zone.value">
                  <el-option label="0" value="0"></el-option>
                  <el-option label="1" value="1"></el-option>
                  <el-option label="2" value="2"></el-option>
                </el-select>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.code128.negativeMode") }}</span>
                <el-select size="small" v-model="scanningTools.c128_inverse.value">
                  <el-option :label="$t('message.scanningToolMsg.code128.normalBarcode')" value="0"></el-option>
                  <el-option :label="$t('message.scanningToolMsg.code128.nbrb')" value="1"></el-option>
                </el-select>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.code128.decodingRateEnhancement") }}</span>
                <el-select size="small" v-model="scanningTools.c128_decoding_rate_enhance.value">
                  <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
                  <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
                </el-select>
              </el-col>
            </el-row>
          </div>
        </el-collapse-item>
        <!-- UPC/EAN -->
        <el-collapse-item>
          <template slot="title">
            <span class="code-font">UPC/EAN</span>
          </template>
          <div>
            <el-row>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">UPC-A</span>
                <el-select size="small" v-model="scanningTools.upca.value">
                  <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
                  <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
                </el-select>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">UPC-E</span>
                <el-select size="small" v-model="scanningTools.upce.value">
                  <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
                  <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
                </el-select>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">UPC-E1</span>
                <el-select size="small" v-model="scanningTools.upce1.value">
                  <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
                  <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
                </el-select>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">EAN-8</span>
                <el-select size="small" v-model="scanningTools.ean8.value">
                  <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
                  <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
                </el-select>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">EAN-13</span>
                <el-select size="small" v-model="scanningTools.ean13.value">
                  <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
                  <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
                </el-select>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.UPC.transmitUPCA") }}</span>
                <el-select size="small" v-model="scanningTools.upca_chk.value">
                  <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
                  <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
                </el-select>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.UPC.transmitUPCE") }}</span>
                <el-select size="small" v-model="scanningTools.upce_chk.value">
                  <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
                  <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
                </el-select>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.UPC.transmitEAN13") }}</span>
                <el-select size="small" v-model="scanningTools.ean13_chk_send.value">
                  <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
                  <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
                </el-select>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.UPC.transmitEAN8") }}</span>
                <el-select size="small" v-model="scanningTools.ean8_chk_send.value">
                  <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
                  <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
                </el-select>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.UPC.UPCAPlusPrefix") }}</span>
                <el-select size="small" v-model="scanningTools.upca_pream.value">
                  <el-option :label="$t('message.scanningToolMsg.UPC.doNotAdd')" value="0"></el-option>
                  <el-option :label="$t('message.scanningToolMsg.UPC.addSystemCharactersOnly')" value="1"></el-option>
                  <el-option :label="$t('message.scanningToolMsg.UPC.addCountryNumber')" value="2"></el-option>
                </el-select>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.UPC.UPCEPlusPrefix") }}</span>
                <el-select size="small" v-model="scanningTools.upce_pream.value">
                  <el-option :label="$t('message.scanningToolMsg.UPC.doNotAdd')" value="0"></el-option>
                  <el-option :label="$t('message.scanningToolMsg.UPC.addSystemCharactersOnly')" value="1"></el-option>
                </el-select>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.UPC.UPCEExtension") }}</span>
                <el-select size="small" v-model="scanningTools.upce_expanded.value">
                  <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
                  <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
                </el-select>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.UPC.UPCAAdditional2") }}</span>
                <el-select size="small" v-model="scanningTools.upca_2char_addenda.value">
                  <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
                  <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
                </el-select>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.UPC.UPCAAdditional5") }}</span>
                <el-select size="small" v-model="scanningTools.upca_5char_addenda.value">
                  <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
                  <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
                </el-select>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.UPC.UPCEAdditional2") }}</span>
                <el-select size="small" v-model="scanningTools.upce_2char_addenda.value">
                  <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
                  <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
                </el-select>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.UPC.UPCEAdditional5") }}</span>
                <el-select size="small" v-model="scanningTools.upce_5char_addenda.value">
                  <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
                  <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
                </el-select>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.UPC.EAN13Additional2") }}</span>
                <el-select size="small" v-model="scanningTools.ean13_2char_addenda.value">
                  <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
                  <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
                </el-select>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.UPC.EAN13Additional5") }}</span>
                <el-select size="small" v-model="scanningTools.ean13_5char_addenda.value">
                  <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
                  <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
                </el-select>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.UPC.EAN8Additional2") }}</span>
                <el-select size="small" v-model="scanningTools.ean8_2char_addenda.value">
                  <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
                  <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
                </el-select>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.UPC.EAN8Additional5") }}</span>
                <el-select size="small" v-model="scanningTools.ean8_5char_addenda.value">
                  <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
                  <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
                </el-select>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.UPC.quietZone") }}</span>
                <el-select size="small" v-model="scanningTools.upc_ean_quiet_zone.value">
                  <el-option label="0" value="0"></el-option>
                  <el-option label="1" value="1"></el-option>
                  <el-option label="2" value="2"></el-option>
                </el-select>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.UPC.negativeMode") }}</span>
                <el-select size="small" v-model="scanningTools.upc_inverse.value">
                  <el-option :label="$t('message.scanningToolMsg.UPC.normalBarcode')" value="0"></el-option>
                  <el-option :label="$t('message.scanningToolMsg.UPC.nbrb')" value="1"></el-option>
                </el-select>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.UPC.decodingRateEnhancement") }}</span>
                <el-select size="small" v-model="scanningTools.ean_decoding_rate_enhance.value">
                  <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
                  <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
                </el-select>
              </el-col>
            </el-row>
          </div>
        </el-collapse-item>
        <!-- code 39 -->
        <el-collapse-item>
          <template slot="title">
            <span class="code-font">Code 39</span>
          </template>
          <div>
            <el-row>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">Code 39</span>
                <el-select size="small" v-model="scanningTools.code39.value">
                  <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
                  <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
                </el-select>
              </el-col>

              <el-col :span="10" class="setting-box">
                <span class="setTitle">Code 39 FULL ASCII</span>
                <el-select size="small" v-model="scanningTools.code39_full_ascii.value">
                  <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
                  <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
                </el-select>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.code39.minimum") }}</span>
                <el-input-number v-model="scanningTools.code39_len_min.value" :min="0" :max="48"
                  size="small"></el-input-number>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.code39.maximum") }}</span>
                <el-input-number v-model="scanningTools.code39_len_max.value" :min="0" :max="48"
                  size="small"></el-input-number>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.code39.transmissionCheckCode") }}</span>
                <el-select size="small" v-model="scanningTools.code39_chk.value">
                  <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
                  <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
                </el-select>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.code39.checkCode") }}</span>
                <el-select size="small" v-model="scanningTools.code39_ver.value">
                  <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
                  <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
                </el-select>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.code39.code39Character") }}</span>
                <el-select size="small" v-model="scanningTools.code39_start_stop.value">
                  <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
                  <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
                </el-select>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.code39.quietZone") }}</span>
                <el-select size="small" v-model="scanningTools.code39_quiet_zone.value">
                  <el-option label="0" value="0"></el-option>
                  <el-option label="1" value="1"></el-option>
                  <el-option label="2" value="2"></el-option>
                </el-select>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.code39.negativeMode") }}</span>
                <el-select size="small" v-model="scanningTools.code39_inverse.value">
                  <el-option :label="$t('message.scanningToolMsg.code39.normalBarcode')" value="0"></el-option>
                  <el-option :label="$t('message.scanningToolMsg.code39.nbrb')" value="1"></el-option>
                </el-select>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.code39.decodingRateEnhancement") }}</span>
                <el-select size="small" v-model="scanningTools.c39_decoding_rate_enhance.value">
                  <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
                  <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
                </el-select>
              </el-col>
            </el-row>
          </div>
        </el-collapse-item>
        <!-- code 93 -->
        <el-collapse-item>
          <template slot="title">
            <span class="code-font">Code 93</span>
          </template>
          <div>
            <el-row>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">Code 93</span>
                <el-select size="small" v-model="scanningTools.code93.value">
                  <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
                  <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
                </el-select>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.code93.minimum") }}</span>
                <el-input-number v-model="scanningTools.code93_len_min.value" :min="0" :max="80" size="small"></el-input-number>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.code93.maximum") }}</span>
                <el-input-number v-model="scanningTools.code93_len_max.value" :min="0" :max="80" size="small"></el-input-number>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.code93.quietZone") }}</span>
                <el-select size="small" v-model="scanningTools.code93_quiet_zone.value">
                  <el-option label="0" value="0"></el-option>
                  <el-option label="1" value="1"></el-option>
                </el-select>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.code93.negativeMode") }}</span>
                <el-select size="small" v-model="scanningTools.code93_inverse.value">
                  <el-option :label="$t('message.scanningToolMsg.code93.normalBarcode')" value="0"></el-option>
                  <el-option :label="$t('message.scanningToolMsg.code93.nbrb')" value="1"></el-option>
                </el-select>
              </el-col>
            </el-row>
          </div>
        </el-collapse-item>
        <!-- code 11 -->
        <el-collapse-item>
          <template slot="title">
            <span class="code-font">Code 11</span>
          </template>
          <div>
            <el-row>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">Code 11</span>
                <el-select size="small" v-model="scanningTools.code11.value">
                  <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
                  <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
                </el-select>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.code11.minimum") }}</span>
                <el-input-number v-model="scanningTools.code11_len_min.value" :min="1" :max="80" size="small"></el-input-number>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.code11.maximum") }}</span>
                <el-input-number v-model="scanningTools.code11_len_max.value" :min="1" :max="80" size="small"></el-input-number>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.code11.transmissionCheckCode") }}</span>
                <el-select size="small" v-model="scanningTools.code11_chk.value">
                  <el-option :label="$t('message.scanningToolMsg.code11.twoCheckBitsAndTransmit')" value="0"></el-option>
                  <el-option :label="$t('message.scanningToolMsg.code11.oneCheckBitsAndTransmit')" value="1"></el-option>
                  <el-option :label="$t('message.scanningToolMsg.code11.twoWithoutTransmit')" value="2"></el-option>
                  <el-option :label="$t('message.scanningToolMsg.code11.oneWithoutTransmit')" value="3"></el-option>
                  <el-option :label="$t('message.scanningToolMsg.code11.notcheck')" value="4"></el-option>
                </el-select>
              </el-col>
            </el-row>
          </div>
        </el-collapse-item>
        <!-- Interleaved 2 of 5 -->
        <el-collapse-item>
          <template slot="title">
            <span class="code-font">Interleaved 2 of 5</span>
          </template>
          <div>
            <el-row>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">Interleaved 2 of 5</span>
                <el-select size="small" v-model="scanningTools.i25.value">
                  <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
                  <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
                </el-select>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.Interleaved2Of5.minimum") }}</span>
                <el-input-number :min="2" :max="80" size="small" v-model="scanningTools.i25_len_min.value"></el-input-number>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.Interleaved2Of5.maximum") }}</span>
                <el-input-number v-model="scanningTools.i25_len_max.value" :min="2" :max="80" size="small"></el-input-number>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.Interleaved2Of5.checkCode") }}</span>
                <el-select size="small" v-model="scanningTools.i25_chk.value">
                  <el-option :label="$t('message.scanningToolMsg.Interleaved2Of5.null')" value="0"></el-option>
                  <el-option :label="$t('message.scanningToolMsg.Interleaved2Of5.CheckNoTransmit')" value="1"></el-option>
                  <el-option :label="$t('message.scanningToolMsg.Interleaved2Of5.CheckAndTransmit')" value="2"></el-option>
                </el-select>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.Interleaved2Of5.staticZone") }}</span>
                <el-select size="small" v-model="scanningTools.i25_quiet_zone.value">
                  <el-option label="0" value="0"></el-option>
                  <el-option label="1" value="1"></el-option>
                  <el-option label="2" value="2"></el-option>
                </el-select>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.Interleaved2Of5.bfConvertToEAN13") }}
                </span>
                <el-select size="small" v-model="scanningTools.i25_to_ean13.value">
                  <el-option :label="$t('message.systemMsg.switchSelect.open')" :value="1"></el-option>
                  <el-option :label="$t('message.systemMsg.switchSelect.close')" :value="0"></el-option>
                </el-select>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.Interleaved2Of5.negativeMode") }}</span>
                <el-select size="small" v-model="scanningTools.i25_inverse.value">
                  <el-option :label="$t('message.scanningToolMsg.Interleaved2Of5.normalBarcode')" value="0"></el-option>
                  <el-option :label="$t('message.scanningToolMsg.Interleaved2Of5.nbrb')" value="1"></el-option>
                </el-select>
              </el-col>
            </el-row>
          </div>
        </el-collapse-item>
        <!-- Codabar -->
        <el-collapse-item>
          <template slot="title">
            <span class="code-font">Codabar</span>
          </template>
          <div>
            <el-row>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">Codabar</span>
                <el-select size="small" v-model="scanningTools.codabar.value">
                  <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
                  <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
                </el-select>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.Codabar.minimum") }}</span>
                <el-input-number v-model="scanningTools.codabar_len_min.value" :min="2" :max="60" size="small"></el-input-number>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.Codabar.maximum") }}</span>
                <el-input-number v-model="scanningTools.codabar_len_max.value" :min="2" :max="60" size="small"></el-input-number>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.Codabar.startStopBit") }}</span>
                <el-select size="small" v-model="scanningTools.codabar_stop_start.value">
                  <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
                  <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
                </el-select>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.Codabar.quietZone") }}</span>
                <el-select size="small" v-model="scanningTools.codabar_quiet_zone.value">
                  <el-option label="0" value="0"></el-option>
                  <el-option label="1" value="1"></el-option>
                </el-select>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.Codabar.negativeMode") }}</span>
                <el-select size="small" v-model="scanningTools.codabar_inverse.value">
                  <el-option :label="$t('message.scanningToolMsg.Codabar.normalBarcode')" value="0"></el-option>
                  <el-option :label="$t('message.scanningToolMsg.Codabar.nbrb')" value="1"></el-option>
                </el-select>
              </el-col>
            </el-row>
          </div>
        </el-collapse-item>
        <!-- NEC 2 of 5 -->
        <el-collapse-item>
          <template slot="title">
            <span class="code-font">NEC 2 of 5</span>
          </template>
          <div>
            <el-row>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">NEC 2 of 5</span>
                <el-select size="small" v-model="scanningTools.nec25.value">
                  <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
                  <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
                </el-select>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.NEC2Of5.minimum") }}</span>
                <el-input-number v-model="scanningTools.nec25_len_min.value" :min="4" :max="80" size="small"></el-input-number>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.NEC2Of5.maximum") }}</span>
                <el-input-number v-model="scanningTools.nec25_len_max.value" :min="4" :max="80" size="small"></el-input-number>
              </el-col>
            </el-row>
          </div>
        </el-collapse-item>
        <!-- MSI -->
        <el-collapse-item>
          <template slot="title">
            <span class="code-font">MSI</span>
          </template>
          <div>
            <el-row>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">MSI</span>
                <el-select size="small" v-model="scanningTools.msi.value">
                  <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
                  <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
                </el-select>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.MSI.minimum") }}</span>
                <el-input-number v-model="scanningTools.msi_len_min.value" :min="4" :max="48" size="small"></el-input-number>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.MSI.maximum") }}</span>
                <el-input-number v-model="scanningTools.msi_len_max.value" :min="4" :max="48" size="small"></el-input-number>
              </el-col>
            </el-row>
          </div>
        </el-collapse-item>
        <!-- RSS -->
        <el-collapse-item>
          <template slot="title">
            <span class="code-font">RSS</span>
          </template>
          <div>
            <el-row>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">RSS-14</span>
                <el-select size="small" v-model="scanningTools.rss14.value">
                  <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
                  <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
                </el-select>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.RSS.restriction") }}</span>
                <el-select size="small" v-model="scanningTools.rss_limit.value">
                  <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
                  <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
                </el-select>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.RSS.extension") }}</span>
                <el-select size="small" v-model="scanningTools.rss_expanded.value">
                  <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
                  <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
                </el-select>
              </el-col>
            </el-row>
          </div>
        </el-collapse-item>
        <!-- QR -->
        <el-collapse-item>
          <template slot="title">
            <span class="code-font">QR</span>
          </template>
          <div>
            <el-row>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">QR Code</span>
                <el-select size="small" v-model="scanningTools.qrcode.value">
                  <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
                  <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
                </el-select>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.QR.minimum") }}</span>
                <el-input-number :min="1" :max="7089" size="small" v-model="scanningTools.qrcode_len_min.value"></el-input-number>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.QR.maximum") }}</span>
                <el-input-number :min="1" :max="7089" size="small" v-model="scanningTools.qrcode_len_max.value"></el-input-number>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">QR Inverse</span>
                <el-select size="small" v-model="scanningTools.qrinverse.value">
                  <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
                  <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
                </el-select>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">MicroQR</span>
                <el-select size="small" v-model="scanningTools.microqr.value">
                  <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
                  <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
                </el-select>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">QR Mirror</span>
                <el-select size="small" v-model="scanningTools.qrmirror.value">
                  <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
                  <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
                </el-select>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">MicroQRInverse</span>
                <el-select size="small" v-model="scanningTools.microqrinverse.value">
                  <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
                  <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
                </el-select>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.QR.quietZone") }}</span>
                <el-select size="small" v-model="scanningTools.qr_quiet_zone.value">
                  <el-option label="0" value="0"></el-option>
                  <el-option label="1" value="1"></el-option>
                </el-select>
              </el-col>
            </el-row>
          </div>
        </el-collapse-item>
        <!-- Data Matrix -->
        <el-collapse-item>
          <template slot="title">
            <span class="code-font">Data Matrix</span>
          </template>
          <div>
            <el-row>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.DataMatrix.dataMatrix") }}</span>
                <el-select size="small" v-model="scanningTools.dm.value">
                  <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
                  <el-option :label="$t('message.scanningToolMsg.DataMatrix.normalBarcode')" value="1"></el-option>
                  <el-option :label="$t('message.scanningToolMsg.DataMatrix.inverseBarcode')" value="2"></el-option>
                  <el-option :label="$t('message.scanningToolMsg.DataMatrix.nbrb')" value="3"></el-option>
                </el-select>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.DataMatrix.minimum") }}</span>
                <el-input-number v-model="scanningTools.dm_len_min.value" :min="1" :max="3166" size="small"></el-input-number>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.DataMatrix.maximum") }}</span>
                <el-input-number v-model="scanningTools.dm_len_max.value" :min="1" :max="3166" size="small"></el-input-number>
              </el-col>
            </el-row>
          </div>
        </el-collapse-item>
        <!-- China Post -->
        <el-collapse-item>
          <template slot="title">
            <span class="code-font">China Post</span>
          </template>
          <div>
            <el-row>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">China Post</span>
                <el-select size="small" v-model="scanningTools.chinapost.value">
                  <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
                  <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
                </el-select>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.ChinaPost.minimum") }}</span>
                <el-input-number v-model="scanningTools.chinapost_len_min.value" :min="4" :max="80" size="small"></el-input-number>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.ChinaPost.maximum") }}</span>
                <el-input-number v-model="scanningTools.chinapost_len_max.value" :min="4" :max="80" size="small"></el-input-number>
              </el-col>
            </el-row>
          </div>
        </el-collapse-item>
        <!-- Matrix 2 of 5 -->
        <el-collapse-item>
          <template slot="title">
            <span class="code-font">Matrix 2 of 5</span>
          </template>
          <div>
            <el-row>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">Matrix 2 of 5</span>
                <el-select size="small" v-model="scanningTools.m25.value">
                  <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
                  <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
                </el-select>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.Matrix2Of5.Matrix2Of5minimum") }}</span>
                <el-input-number v-model="scanningTools.m25_len_min.value" :min="4" :max="80" size="small"></el-input-number>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.Matrix2Of5.Matrix2Of5maximum") }}</span>
                <el-input-number v-model="scanningTools.m25_len_max.value" :min="4" :max="80" size="small"></el-input-number>
              </el-col>
            </el-row>
          </div>
        </el-collapse-item>
        <!-- Composite -->
        <el-collapse-item>
          <template slot="title">
            <span class="code-font">Composite</span>
          </template>
          <div>
            <el-row>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.Composite.hybrid") }}
                </span>
                <el-select size="small" v-model="scanningTools.composite_upcean.value">
                  <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
                  <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
                </el-select>
              </el-col>
            </el-row>
          </div>
        </el-collapse-item>
        <!-- PDF417 -->
        <el-collapse-item>
          <template slot="title">
            <span class="code-font">PDF417</span>
          </template>
          <div>
            <el-row>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">PDF417</span>
                <el-select size="small" v-model="scanningTools.pdf417.value">
                  <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
                  <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
                </el-select>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.PDF417.PDF417minimum") }}</span>
                <el-input-number :min="1" :max="2750" size="small" v-model="scanningTools.pdf417_len_min.value"></el-input-number>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.PDF417.PDF417maximum") }}</span>
                <el-input-number :min="1" :max="2750" size="small" v-model="scanningTools.pdf417_len_max.value"></el-input-number>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.PDF417.negativeMode") }}</span>
                <el-select size="small" v-model="scanningTools.pdf417_inverse.value">
                  <el-option :label="$t('message.scanningToolMsg.PDF417.normalBarcode')" value="0"></el-option>
                  <el-option :label="$t('message.scanningToolMsg.PDF417.nbrb')" value="1"></el-option>
                </el-select>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.PDF417.decodingRateEnhancement") }}</span>
                <el-select size="small" v-model="scanningTools.pdf417_decoding_rate_enhance.value">
                  <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
                  <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
                </el-select>
              </el-col>
            </el-row>
          </div>
        </el-collapse-item>
        <!-- MicroPDF417 -->
        <el-collapse-item>
          <template slot="title">
            <span class="code-font">MicroPDF417</span>
          </template>
          <div>
            <el-row>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">MicroPDF417</span>
                <el-select size="small" v-model="scanningTools.micropdf417.value">
                  <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
                  <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
                </el-select>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.MicroPDF417.MicroPDF417minimum") }}</span>
                <el-input-number :min="1" :max="2750" size="small" v-model="scanningTools.micropdf417_len_min.value"></el-input-number>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.MicroPDF417.MicroPDF417maximum") }}</span>
                <el-input-number :min="1" :max="2750" size="small" v-model="scanningTools.micropdf417_len_max.value"></el-input-number>
              </el-col>
            </el-row>
          </div>
        </el-collapse-item>
        <!-- MaxiCode -->
        <el-collapse-item>
          <template slot="title">
            <span class="code-font">MaxiCode</span>
          </template>
          <div>
            <el-row>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">MaxiCode</span>
                <el-select size="small" v-model="scanningTools.maxicode.value">
                  <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
                  <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
                </el-select>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.MaxiCode.MaxiCodeminimum") }}</span>
                <el-input-number :min="1" :max="150" size="small" v-model="scanningTools.maxicode_len_min.value"></el-input-number>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.MaxiCode.MaxiCodemaximum") }}</span>
                <el-input-number :min="1" :max="150" size="small" v-model="scanningTools.maxicode_len_max.value"></el-input-number>
              </el-col>
            </el-row>
          </div>
        </el-collapse-item>
        <!-- Aztec -->
        <el-collapse-item>
          <template slot="title">
            <span class="code-font">Aztec</span>
          </template>
          <div>
            <el-row>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">Aztec</span>
                <el-select size="small" v-model="scanningTools.azteccode.value">
                  <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
                  <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
                </el-select>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.Aztec.Aztecminimum") }}</span>
                <el-input-number :min="1" :max="3832" size="small" v-model="scanningTools.azteccode_len_min.value"></el-input-number>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.Aztec.Aztecmaximum") }}</span>
                <el-input-number :min="1" :max="3832" size="small" v-model="scanningTools.azteccode_len_max.value"></el-input-number>
              </el-col>
            </el-row>
          </div>
        </el-collapse-item>
        <!-- Codablock F -->
        <el-collapse-item>
          <template slot="title">
            <span class="code-font">Codablock F</span>
          </template>
          <div>
            <el-row>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">Codablock F</span>
                <el-select size="small" v-model="scanningTools.codeblockf.value">
                  <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
                  <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
                </el-select>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.CodablockF.CodablockFminimum") }}</span>
                <el-input-number :min="0" :max="2048" size="small" v-model="scanningTools.codeblockf_len_min.value"></el-input-number>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.CodablockF.CodablockFmaximum") }}</span>
                <el-input-number :min="0" :max="2048" size="small" v-model="scanningTools.codeblockf_len_max.value"></el-input-number>
              </el-col>
            </el-row>
          </div>
        </el-collapse-item>
        <!-- Telepen -->
        <el-collapse-item>
          <template slot="title">
            <span class="code-font">Telepen</span>
          </template>
          <div>
            <el-row>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">Telepen</span>
                <el-select size="small" v-model="scanningTools.telepen.value">
                  <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
                  <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
                </el-select>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.Telepen.Telepenminimum") }}</span>
                <el-input-number :min="1" :max="60" size="small" v-model="scanningTools.telepen_len_min.value"></el-input-number>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.Telepen.Telepenmaximum") }}</span>
                <el-input-number :min="1" :max="60" size="small" v-model="scanningTools.telepen_len_max.value"></el-input-number>
              </el-col>
            </el-row>
          </div>
        </el-collapse-item>
        <!-- OCR -->
        <el-collapse-item>
          <template slot="title">
            <span class="code-font">OCR</span>
          </template>
          <div>
            <el-row>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">OCR</span>
                <el-select size="small" v-model="scanningTools.ocr.value">
                  <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
                  <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
                </el-select>
              </el-col>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">{{ $t("message.scanningToolMsg.OCR.templateSelection") }}</span>
                <el-select size="small" v-model="scanningTools.ocr_template.value">
                  <el-option label="User" value="1"></el-option>
                  <el-option label="Passport" value="2"></el-option>
                </el-select>
              </el-col>
              <el-col :span="10" class="setting-box" v-show="scanningTools.ocr_template.value == 1">
                <span class="setTitle">{{ $t("message.scanningToolMsg.OCR.OCRValue") }}</span>
                <el-input size="small" v-model="scanningTools.qrc_template.value"></el-input>
              </el-col>
            </el-row>
          </div>
        </el-collapse-item>
        <!-- Hanxin code -->
        <el-collapse-item>
          <template slot="title">
            <span class="code-font">Hanxin code</span>
          </template>
          <div>
            <el-row>
              <el-col :span="10" class="setting-box">
                <span class="setTitle">Hanxin code</span>
                <el-select size="small" v-model="scanningTools.hanxin.value">
                  <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
                  <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
                </el-select>
              </el-col>
            </el-row>
          </div>
        </el-collapse-item>
      </el-collapse>
    </el-row>
  </div>
</template>
<script>
export default {
  props: {
    scanToolDataNoFilter: {
      type: Object
    }
  },
  data() {
    return {
    };
  },
  computed: {
    valueChange() {
      let value = "";
      for (const key in this.scanningTools) {
        value += this.scanningTools[key].value;
      }
      return value;
    },
    scanningTools() {
      return this.scanToolDataNoFilter;
    }
  },
  watch: {
    valueChange: {
      handler() {
        if (
          this.scanningTools.code128_len_min.value >
          this.scanningTools.code128_len_max.value
        ) {
          this.$message.closeAll();
          this.$message({
            message: this.$t("message.messageMsg.minLagermax"),
            type: "warning",
          });
          this.$nextTick(() => {
            this.$set(this.scanningTools.code128_len_max, "value", undefined);
            this.$set(this.scanningTools.code128_len_min, "value", undefined);
          });
        }
        if (
          this.scanningTools.code39_len_min.value >
          this.scanningTools.code39_len_max.value
        ) {
          this.$message.closeAll();
          this.$message({
            message: this.$t("message.messageMsg.minLagermax"),
            type: "warning",
          });
          this.$nextTick(() => {
            this.scanningTools.code39_len_min.value = undefined;
            this.scanningTools.code39_len_max.value = undefined;
          });
        }
        if (
          this.scanningTools.code93_len_min.value >
          this.scanningTools.code93_len_max.value
        ) {
          this.$message.closeAll();
          this.$message({
            message: this.$t("message.messageMsg.minLagermax"),
            type: "warning",
          });
          this.$nextTick(() => {
            this.scanningTools.code93_len_min.value = undefined;
            this.scanningTools.code93_len_max.value = undefined;
          });
        }
        if (
          this.scanningTools.code11_len_min.value >
          this.scanningTools.code11_len_max.value
        ) {
          this.$message.closeAll();
          this.$message({
            message: this.$t("message.messageMsg.minLagermax"),
            type: "warning",
          });
          this.$nextTick(() => {
            this.scanningTools.code11_len_min.value = undefined;
            this.scanningTools.code11_len_max.value = undefined;
          });
        }
        if (
          this.scanningTools.i25_len_min.value >
          this.scanningTools.i25_len_max.value
        ) {
          this.$message.closeAll();
          this.$message({
            message: this.$t("message.messageMsg.minLagermax"),
            type: "warning",
          });
          this.$nextTick(() => {
            this.scanningTools.i25_len_min.value = undefined;
            this.scanningTools.i25_len_max.value = undefined;
          });
        }
        if (
          this.scanningTools.codabar_len_min.value >
          this.scanningTools.codabar_len_max.value
        ) {
          this.$message.closeAll();
          this.$message({
            message: this.$t("message.messageMsg.minLagermax"),
            type: "warning",
          });
          this.$nextTick(() => {
            this.scanningTools.codabar_len_min.value = undefined;
            this.scanningTools.codabar_len_max.value = undefined;
          });
        }
        if (
          this.scanningTools.nec25_len_min.value >
          this.scanningTools.nec25_len_max.value
        ) {
          this.$message.closeAll();
          this.$message({
            message: this.$t("message.messageMsg.minLagermax"),
            type: "warning",
          });
          this.$nextTick(() => {
            this.scanningTools.nec25_len_min.value = undefined;
            this.scanningTools.nec25_len_max.value = undefined;
          });
        }
        if (
          this.scanningTools.msi_len_min.value >
          this.scanningTools.msi_len_max.value
        ) {
          this.$message.closeAll();
          this.$message({
            message: this.$t("message.messageMsg.minLagermax"),
            type: "warning",
          });
          this.$nextTick(() => {
            this.scanningTools.msi_len_min.value = undefined;
            this.scanningTools.msi_len_max.value = undefined;
          });
        }
        if (
          this.scanningTools.qrcode_len_min.value >
          this.scanningTools.qrcode_len_max.value
        ) {
          this.$message.closeAll();
          this.$message({
            message: this.$t("message.messageMsg.minLagermax"),
            type: "warning",
          });
          this.$nextTick(() => {
            this.scanningTools.qrcode_len_min.value = undefined;
            this.scanningTools.qrcode_len_max.value = undefined;
          });
        }
        if (
          this.scanningTools.dm_len_min.value >
          this.scanningTools.dm_len_max.value
        ) {
          this.$message.closeAll();
          this.$message({
            message: this.$t("message.messageMsg.minLagermax"),
            type: "warning",
          });
          this.$nextTick(() => {
            this.scanningTools.dm_len_min.value = undefined;
            this.scanningTools.dm_len_max.value = undefined;
          });
        }
        if (
          this.scanningTools.chinapost_len_min.value >
          this.scanningTools.chinapost_len_max.value
        ) {
          this.$message.closeAll();
          this.$message({
            message: this.$t("message.messageMsg.minLagermax"),
            type: "warning",
          });
          this.$nextTick(() => {
            this.scanningTools.chinapost_len_min.value = undefined;
            this.scanningTools.chinapost_len_max.value = undefined;
          });
        }
        if (
          this.scanningTools.m25_len_min.value >
          this.scanningTools.m25_len_max.value
        ) {
          this.$message.closeAll();
          this.$message({
            message: this.$t("message.messageMsg.minLagermax"),
            type: "warning",
          });
          this.$nextTick(() => {
            this.scanningTools.m25_len_min.value = undefined;
            this.scanningTools.m25_len_max.value = undefined;
          });
        }
        if (
          this.scanningTools.pdf417_len_min.value >
          this.scanningTools.pdf417_len_max.value
        ) {
          this.$message.closeAll();
          this.$message({
            message: this.$t("message.messageMsg.minLagermax"),
            type: "warning",
          });
          this.$nextTick(() => {
            this.scanningTools.pdf417_len_min.value = undefined;
            this.scanningTools.pdf417_len_max.value = undefined;
          });
        }
        if (
          this.scanningTools.micropdf417_len_min.value >
          this.scanningTools.micropdf417_len_max.value
        ) {
          this.$message.closeAll();
          this.$message({
            message: this.$t("message.messageMsg.minLagermax"),
            type: "warning",
          });
          this.$nextTick(() => {
            this.scanningTools.micropdf417_len_min.value = undefined;
            this.scanningTools.micropdf417_len_max.value = undefined;
          });
        }
        if (
          this.scanningTools.maxicode_len_min.value >
          this.scanningTools.maxicode_len_max.value
        ) {
          this.$message.closeAll();
          this.$message({
            message: this.$t("message.messageMsg.minLagermax"),
            type: "warning",
          });
          this.$nextTick(() => {
            this.scanningTools.maxicode_len_min.value = undefined;
            this.scanningTools.maxicode_len_max.value = undefined;
          });
        }
        if (
          this.scanningTools.azteccode_len_min.value >
          this.scanningTools.azteccode_len_max.value
        ) {
          this.$message.closeAll();
          this.$message({
            message: this.$t("message.messageMsg.minLagermax"),
            type: "warning",
          });
          this.$nextTick(() => {
            this.scanningTools.azteccode_len_min.value = undefined;
            this.scanningTools.azteccode_len_max.value = undefined;
          });
        }
        if (
          this.scanningTools.codeblockf_len_min.value >
          this.scanningTools.codeblockf_len_max.value
        ) {
          this.$message.closeAll();
          this.$message({
            message: this.$t("message.messageMsg.minLagermax"),
            type: "warning",
          });
          this.$nextTick(() => {
            this.scanningTools.codeblockf_len_min.value = undefined;
            this.scanningTools.codeblockf_len_max.value = undefined;
          });
        }
        if (
          this.scanningTools.telepen_len_min.value >
          this.scanningTools.telepen_len_max.value
        ) {
          this.$message.closeAll();
          this.$message({
            message: this.$t("message.messageMsg.minLagermax"),
            type: "warning",
          });
          this.$nextTick(() => {
            this.scanningTools.telepen_len_min.value = undefined;
            this.scanningTools.telepen_len_max.value = undefined;
          });
        }
        this.createscanXML();
      },
      immediate: true,
    }
  },
  methods: {
    createscanXML() {
      // 过滤去空数据
      const filteredSettings = Object.entries(this.scanningTools)
        .filter(([key, value]) => value.value !== null && value.value !== undefined)
        .reduce((acc, [key, value]) => {
          acc[key] = value; // 只包含value不为null的属性
          return acc;
        }, {});

      // 给父组件传值
      this.$emit('handleGrandChildEvent', this.scanningTools);
      this.$emit('handleGrandChildEventFilter', filteredSettings);
    },
    // 数据回显
    updateFeatureSettings(originalSettings, updatedSettings) {
      // 遍历 updatedSettings 中的每一个属性
      for (const key in updatedSettings) {
        // 如果 originalSettings 中也存在这个属性
        if (originalSettings.hasOwnProperty(key)) {
          // 并且 updatedSettings 中该属性的 value 不是 null
          if (updatedSettings[key].value !== null) {
            // 则更新 originalSettings 中对应属性的 value
            originalSettings[key].value = updatedSettings[key].value;
          }
        }
      }
      // 返回更新后的 originalSettings（可选，因为原始对象被直接修改）
      return originalSettings;
    },
  },
  created() {
    if (localStorage.getItem("scanJsonData") != null) {
      let updateData = JSON.parse(localStorage.getItem("scanJsonData"));
      this.updateFeatureSettings(this.scanningTools, updateData);
    }
  }
}
</script>
